export default __webpack_public_path__ + "static/media/green-check-icon.fb4ab898.svg";